import React, { useState } from "react";
import { useEffect } from "react";
import styled, { css } from "styled-components";

// input
const InputWrap = ({ children, ...props }) => {
    let { id, title, style, direction } = props;

    return (
        <>
            <div style={{ display: "flex", flexDirection: direction === "col" ? "column" : "row", gap: "5px", justifyContent: "flex-start", alignItems: "center", width: "100%" }}>
                <CustomLabel htmlFor={id} style={style}>
                    {title}
                </CustomLabel>
                {children}
            </div>
        </>
    );
};

const CustomLabel = styled.label`
    font-size: 1.2em;
    letter-spacing: 0.02em;
`;

const Input = ({ children, ...props }) => {
    let { type, name, disabled, placeholder, value, stateValue, onChange, style } = props;
    if (!type) type = "text";

    const onChangeHandler = (e) => {
        if (onChange) {
            onChange(e);
        } else {
            stateValue[1]({ ...stateValue[0], [name]: e.target.value });
        }
    };

    return (
        <>
            <CustomInput type={type} name={name} id={name} style={style} disabled={disabled} placeholder={placeholder} defaultValue={value} maxLength={100} onChange={(e) => onChangeHandler(e)} />
        </>
    );
};

const CustomInput = styled.input`
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.02em;
    padding: 7px 10px;
    background-color: #fff;
    border: 1px solid var(--divider-dark);
    border-radius: 8px;
    outline: 0;
`;

// textarea
const Textarea = ({ children, ...props }) => {
    let { name, id, disabled, placeholder, value, stateValue, onChange, style } = props;

    const onChangeHandler = (e) => {
        if (onChange) {
            onChange(e);
        } else {
            stateValue[1]({ ...stateValue[0], [name]: e.target.value });
        }
    };

    return (
        <>
            <CustomTextarea name={name} id={id} disabled={disabled} style={style} placeholder={placeholder} value={value ?? ""} onChange={(e) => onChangeHandler(e)}></CustomTextarea>
        </>
    );
};

const CustomTextarea = styled.textarea.attrs({ rows: 2 })`
    height: 80px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.02em;
    padding: 12px 16px;
    background-color: #fff;
    border: 1px solid var(--divider-dark);
    border-radius: 8px;
    outline: 0;
`;

export { InputWrap, Input, Textarea };
